import { useQuery } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import { Matter } from '@/api/types/backend-dto-types';
import useGetFetchConfig from '@/api/useGetFetchConfig';

export const useGetMatters = () => {
  const { fetchConfigGET } = useGetFetchConfig();

  const fetchMatters = async (): Promise<Matter[]> => {
    const response = await fetch(`${APIBaseChronos}/api/matters`, fetchConfigGET);
    if (!response.ok) {
      throw new Error('Fetching matters failed');
    }
    return response.json();
  };

  return useQuery<Matter[]>([QueryEntity.Matters], fetchMatters, {
    keepPreviousData: true,
    refetchOnWindowFocus: false,
  });
};
